// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"1c474b71","147":"7b5ede7b","348":"df6fbbcf","737":"9424a25a","940":"b60f9314"}[chunkId] + ".chunk.js";
};